import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const currentTitle = ref('TimeSheet')

export function usePageTitle() {
    const route = useRoute()

    // Función para obtener título desde la meta de la ruta
    const getTitleFromRoute = (route) => {
        return route.meta?.title || 'TimeSheet'
    }

    // Inicializar título
    currentTitle.value = getTitleFromRoute(route)

    // Observar cambios de ruta
    watch(() => route.meta?.title, (newTitle) => {
        currentTitle.value = newTitle || 'TimeSheet'
    }, { immediate: true })

    return {
        currentTitle: currentTitle.value,
        setTitle: (title) => {
            currentTitle.value = title
        }
    }
}

// Export para uso directo del título reactivo
export { currentTitle }
